import { use as i18NextUse } from 'i18next';
import { initReactI18next } from 'react-i18next';

import loginEn from '../src/locales/en/login.json';
import formEn from '../src/locales/en/form.json';

const DEFAULT_LANGUAGE = 'en';

i18NextUse(initReactI18next).init({
  debug: false,
  fallbackLng: DEFAULT_LANGUAGE,
  resources: {
    en: {
      login: loginEn,
      form: formEn,
    },
  },
});
